import { updateVariants } from "../../logic/updateVariants"

export default {
    selectedPrestations: (state, getters) => {
        const prestations = getters.prestations || []
        
        // check variants too
        let prestationVariants = []
        prestations.forEach(prest=>{
            if (prest?.variants && Array.isArray(prest.variants)) {
                prestationVariants = [...prest.variants , ...prestationVariants]
            }
        })

        const updatedVariants = updateVariants(prestationVariants) 

        const selectedPrestIds = state.selectedPrestIds
        const filteredPrestations =  [...prestations, ...updatedVariants].filter((prest)=>{
            return !!selectedPrestIds[prest.id]
        })

        return filteredPrestations.map((prest)=>{
            return {
                prestation: prest,
                quantity: selectedPrestIds[prest.id],
            }
        })
    },

    totalSelectedHebergements: (state, getters) => {
        const selectedPrestations = getters.selectedPrestations
        let total = 0
        selectedPrestations.forEach((prestObj)=>{
            total += prestObj.quantity
        })
        return total
    }
}